import { render, staticRenderFns } from "./Continue-Setup.vue?vue&type=template&id=12688cd6&scoped=true&"
import script from "./Continue-Setup.vue?vue&type=script&lang=js&"
export * from "./Continue-Setup.vue?vue&type=script&lang=js&"
import style0 from "./Continue-Setup.vue?vue&type=style&index=0&id=12688cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12688cd6",
  null
  
)

export default component.exports